import { prefixer, createApiConsts } from '../../../Helpers/constants'

const createPrefixedConst = prefixer('AVAYA_AXP_PUBLIC_CONFIG')
const createPrefixedApiConsts = <ApiName extends string>(apiName: ApiName) => createApiConsts(createPrefixedConst(apiName))

export const SELECT_ACTION = createPrefixedConst('SELECT_ACTION')
export const SUBMIT_AVAYA_AXP_PUBLIC_CONFIG = createPrefixedApiConsts('SUBMIT_AVAYA_AXP_PUBLIC_CONFIG')
export const GET_AVAYA_AXP_PUBLIC_CONFIG = createPrefixedApiConsts('GET_AVAYA_AXP_PUBLIC_CONFIG')
export const UPDATE_AVAYA_AXP_PUBLIC_CONFIG = createPrefixedApiConsts('UPDATE_AVAYA_AXP_PUBLIC_CONFIG')
export const GET_METADATA = createPrefixedApiConsts('GET_METADATA')

export const ACD_SERVER = 'ACD Server'
export const DB_SERVER_TYPE = 'AVAYAAXPPUBLIC'
export const PREFIX = 'AvayaAxpPublicConfig-'
